
<a (click)="logout()" class="btn btn-default btn-flat float-right">
    Salir
</a>
